<template>
  <div class="quantity-block">
    <div class="qty">
      <button @click="decrease">-</button>
      <span>{{ quantity }}</span>
      <button @click="increase">+</button>
    </div>
    <span v-if="showWarning" class="warning">{{messages.available}} {{ max }} шт.</span>
  </div>
</template>

<script>
import {mapActions} from 'vuex';
export default {
  name: "QuantityBlock",
  props: {
    item: {
      type: Object,
      default: {}
    },
    messages: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      id: this.item.id,
      quantity: this.item.quantity,
      max: this.item.availableQuantity,
      messages: this.messages,
      showWarning: false
    };
  },
  methods: {
    ...mapActions({
      update: 'basket/update',
    }),
    increase() {
      if (this.quantity < this.max) {
        this.quantity++;
        this.updateBasket();

        this.showWarning = false;
      } else {
        this.showWarning = true;
      }
    },
    decrease() {
      if (this.quantity > 1) {
        this.quantity--;
        this.updateBasket();

        this.showWarning = false;
      }
    },
    async updateBasket() {
      await this.update({id: this.id, count: this.quantity});
    }
  }
};
</script>

<style lang="scss" scoped>

.quantity-block {
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: 400;

  .qty {
    display: flex;
    align-items: center;
    color: #858585;

    button {
      background: none;
      border: none;
      padding: 2px 0;
      cursor: pointer;
      color: #858585;
    }
    span {
      padding: 0 9px;
    }
  }

  .warning {
    color: #D775AF;
  }

  @media (max-width: 992px) {
    font-size: 16px;

    .warning {
      font-size: 14px;
      margin-left: 4px;
    }
  }
}

</style>